import React, { FC, useEffect, useState } from 'react';
import { InventoryItemData } from './inventoryItemData';
import styles from './styles.module.css';
import { ReactComponent as InventoryItemPriceIcon } from '../../../assets/icons/inventory-item-price.svg';
import { ReactComponent as InventoryItemQuantityIcon } from '../../../assets/icons/inventory-item-quantity.svg';

import { IBaseInventoryItem } from './types';
import UpdateBaseMealQuantityModal from '../modals/update-base-meal-quantity-modal';

type Props = {
  meal: IBaseInventoryItem;
};

const InventoryBaseMealItem: FC<Props> = ({ meal }: Props) => {
  const [editableMeal, setEditableMeal] = useState(meal);
  const [showModal, setShowModal] = useState(false);
  const [type, setType] = useState<'add' | 'reduce'>('add');
  useEffect(() => setEditableMeal(meal), [meal]);

  return (
    <div className={styles.main}>
      <div className={styles.title}>
        <div className={Number(meal.quantity) > 0 ? '' : styles.titleDisabled}>
          {meal.base_meal?.name}
          {Number(meal.quantity)?.toFixed(0) === '0' && (
            <div className={styles.soldOut}>Sold out</div>
          )}
        </div>
      </div>
      <div className='flex justify-between items-center'>
        <div className={styles.detail}>
          <InventoryItemData
            Icon={InventoryItemQuantityIcon}
            value={Number(meal.quantity)?.toFixed(0)}
            edit={false}
          />
          <InventoryItemData
            Icon={InventoryItemPriceIcon}
            value={Number(meal.quantity)?.toFixed(0) > '0' ? 'Available' : 'Not Available'}
            edit={false} //updating amount no longer happens here
          />
        </div>
        <div className={styles.actions}>
          <div className='flex gap-2 ml-2  items-center'>
            <button
              className={styles.lineButton}
              onClick={() => {
                setShowModal(true);
                setType('add');
              }}>
              Add
            </button>
            <button
              className={styles.lineButton}
              onClick={() => {
                setShowModal(true);
                setType('reduce');
              }}>
              Reduce
            </button>
          </div>
        </div>
      </div>

      <UpdateBaseMealQuantityModal
        meal={meal}
        show={showModal}
        onClose={() => setShowModal(false)}
        type={type}
        onConfirm={({ quantity }) =>
          setEditableMeal({
            ...editableMeal,
            quantity:
              type === 'add'
                ? String(Number(editableMeal.quantity) + Number(quantity))
                : String(Number(editableMeal.quantity) - Number(quantity))
          })
        }
      />
    </div>
  );
};

export default InventoryBaseMealItem;
